module.exports = __webpack_public_path__ + "static/inno1-edb95b255e3832807fd224690093232a.jpg";